// Shared gradient/border recipe for stat-card style cards (dashboard, analytics, ...)
// so a future design tweak doesn't need to be hand-copied into every usage.
export function statCardGradientSx(color) {
  return {
    backgroundImage: `linear-gradient(135deg, ${color}30 0%, ${color}20 100%)`,
    border: '2px solid',
    borderColor: color,
  };
}
